var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.727 9.02a5.5 5.5 0 1 0-.707.707l5.672 5.672.707-.707zm-1.045-.338a4.5 4.5 0 1 1-6.364-6.364 4.5 4.5 0 0 1 6.364 6.364",
  clipRule: "evenodd"
})));
export default SvgSearch;